import * as React from "react";

function Laugh(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.75 9a8.25 8.25 0 1016.5 0A8.25 8.25 0 00.75 9zm15 0a6.75 6.75 0 11-13.5 0 6.75 6.75 0 0113.5 0zm-6.726 5.25c-2.518 0-3.92-1.326-3.92-3.75v-.75h7.733l.02.729c.07 2.432-1.307 3.771-3.833 3.771zm2.292-3c-.177 1.047-.884 1.5-2.292 1.5-1.407 0-2.138-.457-2.351-1.5h4.643zM10.5 6h2.25v1.5H10.5V6zm-3 0H5.25v1.5H7.5V6z"
      />
    </svg>
  );
}

export default Laugh;
